export function getInventoryLabelAndColor(quantity: number): { label: string, color: string } {
  if (quantity < 0) {
    return { label: `(Understock: ${quantity})`, color: '#b91c1c' }
  } else if (quantity === 0) {
    return { label: `(Out of stock)`, color: 'red' }
  } else if (quantity < 5) {
    return { label: `(Low stock: ${quantity})`, color: 'orange' }
  } else if (quantity >= 5) {
    return { label: `(Stock: ${quantity})`, color: '#666' }
  }
  return { label: '', color: '' }
}
